"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchClientTransporter = void 0;
var FetchClientTransporter_1 = require("./FetchClientTransporter");
Object.defineProperty(exports, "FetchClientTransporter", { enumerable: true, get: function () { return __importDefault(FetchClientTransporter_1).default; } });
